<template>
    <div class="containerInner">
        <div class="listHeader">
            <div class="headerLeftMenu">
                <span>店舗コード設定</span>
            </div>
            <div class="headerRightMenu">
                <Button @click="openCreateModal">新規追加</Button>
            </div>
        </div>

        <ul class="list" v-if="Object.keys(this.service_settings).length > 0">
            <template v-for="setting in this.service_settings">
                <li class="info" v-bind:key="setting.id">
                    <div class="infoLeft">
                        <h3><span>【{{ setting.service.id }}】</span>{{ setting.service.name }}<span
                                v-if="Number(setting.use_flg) === 1" class="stopped">停止中</span></h3>
                        <p>店舗コード : {{ setting.tempo_code }}</p>
                        <p>画面表示順 : {{ setting.display_sort }}</p>
                    </div>
                    <div class="infoRight">
                        <Button class="btn" @click="openUpdateModal(setting.id)">編集</Button>
                    </div>
                </li>
            </template>
        </ul>
        <div class="listFooter">
        </div>
        <modal name="tempoCodeSettingModal" :draggable="false" :resizable="false" width="60%" height="90%">
            <TempoCodeSettingModal :tempoCodeSettingId="this.selectedId" :createMode="this.createMode"
                @modalClosed="modalClosed('tempoCodeSettingModal')" />
        </modal>
        <div class="loadingWindow" v-show="this.$store.state.loading">
            <div class="loadingWindowInner">
                <p>{{ this.statusMessage }}</p>
                <vue-loaders name="ball-spin-fade-loader" color="#02AD90" scale="1"></vue-loaders>
            </div>
        </div>


    </div>
</template>

<script>
import TempoCodeSettingModal from '../components/TempoCodeSettingModal.vue'

export default {
    components: {
        TempoCodeSettingModal,
    },
    data() {
        return {
            statusMessage: "",
            service_settings: {},
            selectedId: null,
            createMode: true,
        }
    },
    mounted: function () {
        this.getTempoCodeSettings();
    },
    methods: {
        getTempoCodeSettings: function () {
            this.$store.dispatch("loading", true);
            this.axios.get("/api/tempoCodeSettings")
                .then((res) => {
                    this.service_settings = res.data;
                }).catch(() => {
                }).finally(() => {
                    this.$store.dispatch("loading", false);
                });
        },
        openCreateModal: function () {
            this.selectedId = null;
            this.createMode = true;
            this.$modal.show('tempoCodeSettingModal');
        },
        openUpdateModal: function (id) {
            this.selectedId = id;
            this.createMode = false;
            this.$modal.show('tempoCodeSettingModal');
        },
        modalClosed(modalName) {
            this.getTempoCodeSettings();
            this.$store.dispatch("loading", false)
            this.$store.dispatch("successful", false)
            this.$modal.hide(modalName)

        },

    },
    computed: {
    }
}
</script>

<style scoped lang="sass">
.containerInner
    display: inline-grid
    .listHeader
        color: $grayColor
        display: flex
        font-size: 1.4rem
        margin: 20px 140px 0 140px
        padding: 10px 0
        .headerLeftMenu
            flex: 1 1 100%
            span
                display: inline-block
                vertical-align: middle
        .headerRightMenu
            flex: 1 0 auto
            span
                display: inline-block
                text-align: left
                vertical-align: middle
                .addBtn, .adsetUpdateBtn
                    border: 1px solid $mainColor
                    margin-left: 20px
                    padding: 12px
                    width: 170px
                    &:hover
                        border: 1px solid $mainColor
                    span
                        font-size: 0.3rem
    .list
        background: $whiteColor
        font-size: 1.2rem
        margin: 10px 140px 0 140px
        overflow-y: scroll
        .info
            border-bottom: 3px solid #f8f8ff
            color: $grayColor
            display: flex
            justify-content: space-between
            padding: 10px
            .btn
                width: 100px
                margin-left: 20px
                margin-bottom: 8px
            .infoLeft
                display: flex
                flex-direction: column
                justify-content: center
                h3
                    font-size: 1.5rem
                    font-weight: 700
                    margin-bottom: 10px
                    .stopped
                        color: #ff5252
                        margin-left: 12px
                p
                    margin: 0 0 10px 20px
                    font-size: 1.4rem
                    display: flex
                .name
                    font-weight: 700
                .description
                    margin-left: 16px
                .inputText
                    margin-left: 10px
                    padding: 10px
                    width: 200px
                    &:focus
                        outline: 2px solid $mainColor
            .infoRight
                margin-right: 30px
                display: flex
                flex-direction: column
                justify-content: center
                padding: 10px 0
    .listFooter
        margin: 20px 140px 0 140px
        position: relative
        display: flex
        justify-content: center
        .updateBtn
            width: 80px

    .deliverySizeModal
        display: none;
    .loadingWindow
        overflow: hidden
        background: rgba(255, 255, 255, 0.8)
        height: 100%
        left: 0
        position: absolute
        top: 0px
        width: 100vw
        z-index: 1000
        .loadingWindowInner
            left: 50%
            position: absolute
            text-align: center
            top: 50%
            transform: translate(-50%, -50%)
            z-index: 1000
            p
                font-size: 2.5rem
                margin-bottom: 40px
@include sp()
    .containerInner
        .listHeader
            margin: 20px 0 0 10px
        .list
            margin: 10px 0 0
</style>
